exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--color-text:#fff;--color-high-text:#ff5777;--color-tint:#ff8198;--color-background:#d04a02;--font-size:14px;--line-height:1.5;--nav-height:46px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/dist/cjs.js!./src/styles/main.css
// module id = 988
// module chunks = 0